import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Card = styled.div`
    padding: 16px;
    background: ${colors.white};
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
`;

export const Filters = styled.div`
    width: 100%;
    max-width: 353px;
    margin-bottom: 16px;
`;

export const ValueCards = styled.div`
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 16px;

    @media (max-width: 1200px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (max-width: 720px) {
        grid-template-columns: 1fr;
    }
`;

export const ValueCard = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
    border: 1px solid ${colors.border};
    border-radius: 8px;
`;

export const ValueIcon = styled.div<{background: string}>`
    flex: 0 0 auto;
    padding: 12px;
    border-radius: 4px;
    background: ${({background}) => background};
`;

export const ValueTitle = styled.div`
    color: ${colors.textPrimary};
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
`;

export const ValueNumber = styled.div`
    color: ${colors.textPrimary};
    font-size: 24px;
    line-height: 1.2;
    font-weight: 600;
`;

export const ValueCaption = styled.div`
    margin-top: 6px;
    color: ${colors.textSecondary};
    font-size: 12px;
    line-height: 16px;
`;

export const ChartHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
`;

export const ChartTitle = styled.h3`
    margin: 0;
    color: ${colors.textPrimary};
    font-size: 18px;
    line-height: 1.2;
    font-weight: 600;
`;

export const Legend = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const LegendItem = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${colors.textPrimary};
    font-size: 12px;
`;

export const LegendDot = styled.span<{color: string}>`
    width: 12px;
    height: 12px;
    border-radius: 999px;
    background: ${({color}) => color};
`;

export const ChartBox = styled.div`
    height: 225px;
`;

export const DonutContainer = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) 360px;
    align-items: center;
    gap: 24px;

    @media (max-width: 960px) {
        grid-template-columns: 1fr;
    }
`;

export const DonutLegend = styled.div`
    border: 1px solid ${colors.border};
    border-radius: 8px;
    padding: 0 24px;
`;

export const DonutLegendRow = styled.div`
    display: grid;
    grid-template-columns: 24px minmax(0, 1fr) minmax(72px, auto) 75px;
    align-items: center;
    gap: 12px;
    padding: 20px 0;
    border-bottom: 1px solid ${colors.border};
    color: ${colors.textPrimary};
    font-size: 12px;

    &:last-child {
        border-bottom: 0;
    }
`;

export const DonutValue = styled.div`
    justify-self: end;
    font-size: 18px;
    font-weight: 600;
`;

export const DonutPercent = styled.div`
    justify-self: end;
`;

export const DonutChartBox = styled.div`
    height: 312px;
`;
